export default __webpack_public_path__ + "static/media/bitgreen.86685ae4.svg";